import { atom } from 'recoil'
import { makeUniversalCookieAdapter } from '@/main/factories/cache'

export const cookieState = atom({
  key: 'cookie',
  default: makeUniversalCookieAdapter()
})
